import React from "react";
import { json } from "helpers/data";
import ServerImage from "components/server-image/server-image";

interface Props {
  logo: string;
  title: string;
}

function ModuleHeader({ logo, title }: Props) {
  return (
    <div className="header">
      <div className="info">
        <ServerImage className="logo" src={logo} alt="logo" />
        <h1 className="title">{json(title)}</h1>
      </div>
    </div>
  );
}

export default ModuleHeader;
